import "./Spinner.css";

interface SpinnerProps {
  size?: "small" | "large";
  label?: string;
}

const Spinner = ({ size = "large", label }: SpinnerProps) => {
  return (
    <div
      className={`spinner-container spinner-${size}`}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <div className="spinner" aria-hidden="true" />
      <span className={label ? "spinner-label" : "spinner-label-sr-only"}>
        {label || "読み込み中"}
      </span>
    </div>
  );
};

export default Spinner;
